export const serviceListComerciales = [
    {
        "title": "SERVICIO DE",
        "subtitle": "<span>RESTAURACIÓN DE EDIFICIOS</span><br />Y ESTRUCTURAS",
        "description": "El óxido en las estructuras es una amenaza constante que debilita el metal y pone en riesgo la estabilidad y durabilidad de la misma. Dale la limpieza adecuada con nuestros servicios especializados.",
        "features": ["Recubrimientos", "Reparación y Sellado de Fachadas para Empresas", "Rope Access"],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg"
        ],
        "bgColor": "#FFCD00"
    },
    {
        "title": "SERVICIO DE",
        "subtitle": "MANTENIMIENTO",
        "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
        "features": [
            "Limpieza de Ventanas",
            "Limpieza de Fachadas",
            "Rope Access"
        ],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg"
        ],
        "bgColor": "#FFCD00"
    },
    {
        "title": "SERVICIO DE",
        "subtitle": "PINTURA",
        "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
        "features": [
            "Edificios Empresariales",
            "Estructuras",
            "Recubrimiento",
            "Impermeabilizante"
        ],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg"
        ],
        "bgColor": "#FFCD00"
    },
    {
        "title": "SERVICIO DE",
        "subtitle": "INSTALACIÓN",
        "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
        "features": [
            "Fachadas",
            "Alucobond",
            "Piedra",
            "Estructuras",
            "Anuncios Espectaculares",
            "Renta de Andamios"
        ],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg"
        ],
        "bgColor": "#FFCD00"
    },
]

export const serviceListComercialesEn = [
    {
        title: "SERVICE OF",
        subtitle: "<span>BUILDING RESTORATION</span><br />AND STRUCTURES",
        description:
            "Rust on structures is a constant threat that weakens metal and jeopardizes stability and durability. Give them the proper cleaning with our specialized services.",
        features: [
            "Coatings",
            "Facade Repair and Sealing for Commercial Buildings",
            "Rope Access"
        ],
        buttonText: "CONTACT US",
        images: [
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg"
        ],
        bgColor: "#FFCD00"
    },
    {
        title: "SERVICE OF",
        subtitle: "MAINTENANCE",
        description:
            "Prevention is key to keeping your structures in optimal condition. We perform the necessary inspections in a non-invasive manner.",
        features: [
            "Window Cleaning",
            "Facade Cleaning",
            "Rope Access"
        ],
        buttonText: "CONTACT US",
        images: [
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg"
        ],
        bgColor: "#FFCD00"
    },
    {
        title: "SERVICE OF",
        subtitle: "PAINTING",
        description:
            "Prevention is key to keeping your structures in optimal condition. We perform the necessary inspections in a non-invasive manner.",
        features: [
            "Commercial Buildings",
            "Structures",
            "Coatings",
            "Waterproofing"
        ],
        buttonText: "CONTACT US",
        images: [
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg"
        ],
        bgColor: "#FFCD00"
    },
    {
        title: "SERVICE OF",
        subtitle: "INSTALLATION",
        description:
            "Prevention is key to keeping your structures in optimal condition. We perform the necessary inspections in a non-invasive manner.",
        features: [
            "Facades",
            "Alucobond",
            "Stone",
            "Structures",
            "Billboard Signs",
            "Scaffolding Rental"
        ],
        buttonText: "CONTACT US",
        images: [
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg"
        ],
        bgColor: "#FFCD00"
    }
];  